<template>
	<div class="line-chart">
		<chart-base :chart-options="options" :height="height" :width="width"></chart-base>
	</div>
</template>

<script>
import chartMixin, { getMax, getLabel } from './chartMixin.js'

export default {
	name: 'LineChart',
	mixins: [chartMixin],
	computed: {
		options() {
			const label = getLabel(
				{
					distance: 3,
				},
				this.chartOptions.series,
			)
			const baseConfig = {
				xAxis: {
					type: 'category',
					boundaryGap: true,
					data: [],
					axisLine: {
						lineStyle: {
							color: '#E8E8E8',
						},
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						color: '#666',
						fontSize: 11,
					},
					splitLine: {
						lineStyle: {
							color: '#F0F0F0',
							type: 'dashed',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						show: true,
						lineStyle: {
							color: '#E8E8E8',
						},
					},
					axisTick: {
						show: false,
					},
					splitLine: {
						lineStyle: {
							color: '#F0F0F0',
							type: 'dashed',
						},
					},
					axisLabel: {
						color: '#666',
						fontSize: 11,
						formatter: value => {
							if (value === 0) return '0'
							if (value > 1000) return `${(value / 1000).toFixed(1)}k`
							return value
						},
					},
					max: getMax,
					minInterval: 1,
					splitNumber: 5,
				},
				series: [
					{
						type: 'line',
						data: this.data,
						smooth: true,
						itemStyle: {
							color: '#1890FF',
						},
						lineStyle:
							this.chartStyle === 'blue'
								? {
										width: 1,
										color: 'rgba(118, 182, 242, 1)',
										shadowColor: 'rgba(118, 182, 242, 0.4)',
										shadowBlur: 3,
										shadowOffsetY: 3,
								  }
								: {
										width: 1,
										color: 'rgba(137, 121, 255, 1)',
										shadowColor: 'rgba(137, 121, 255, 0.4)',
										shadowBlur: 3,
										shadowOffsetY: 3,
								  },
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [
									{
										offset: 0,
										color:
											this.chartStyle === 'blue'
												? 'rgba(118, 182, 242, 0.3)'
												: 'rgba(137, 121, 255, 0.3)',
									},
									{
										offset: 1,
										color:
											this.chartStyle === 'blue'
												? 'rgba(118, 182, 242, 0.05)'
												: 'rgba(137, 121, 255, 0.05)',
									},
								],
							},
						},
						label,
						showSymbol: true,
						emphasis: {
							show: false,
						},
					},
				],
			}

			const mergedOptions = this.mergeOptions(baseConfig, this.chartOptions)

			// 合并传入的配置
			return mergedOptions
		},
	},
}
</script>

<style lang="scss" scoped>
.line-chart {
	width: 100%;
	height: 100%;
}
</style>
